import { render } from "./VerifyToken.vue?vue&type=template&id=fd1aa9de&ts=true"
import script from "./VerifyToken.vue?vue&type=script&lang=ts"
export * from "./VerifyToken.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/tenanthub.au/runners/admin/root/tenanthub-admin/tenanthub-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__